import { action } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, Duration, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFillGridFill } from '@react-icons/all-files/bs/BsFillGridFill';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { AppStore } from '../../../Core/AppStore';

export enum LiveChartGridOptions {
    OneByOne = '1x1',
    TwoByTwo = '2x2',
    ThreeByThree = '3x3',
    FourByFour = '4x4',
}

@autoinject
@observer
export class LiveChartsGridSelector extends React.Component {
    public render() {
        return (
            <UncontrolledButtonDropdown className="ms-2">
                <DropdownToggle caret color="primary" className="btn-sm">
                    <BsFillGridFill /> &nbsp; {this.appStore.storage.liveChartSettings.liveChartSelectedGrid}
                </DropdownToggle>

                <DropdownMenu>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onGridTypeChange(e, LiveChartGridOptions.OneByOne)}
                        active={
                            this.appStore.storage.liveChartSettings.liveChartSelectedGrid ==
                            LiveChartGridOptions.OneByOne
                        }
                    >
                        {LiveChartGridOptions.OneByOne}
                    </DropdownItem>
                    {!this.appStore.isMobile && (
                        <>
                            <DropdownItem
                                className="text-primary"
                                onClick={e => this.onGridTypeChange(e, LiveChartGridOptions.TwoByTwo)}
                                active={
                                    this.appStore.storage.liveChartSettings.liveChartSelectedGrid ==
                                    LiveChartGridOptions.TwoByTwo
                                }
                            >
                                2x2
                            </DropdownItem>
                            <DropdownItem
                                className="text-primary"
                                onClick={e => this.onGridTypeChange(e, LiveChartGridOptions.ThreeByThree)}
                                active={
                                    this.appStore.storage.liveChartSettings.liveChartSelectedGrid ==
                                    LiveChartGridOptions.ThreeByThree
                                }
                            >
                                3x3
                            </DropdownItem>
                            <DropdownItem
                                className="text-primary"
                                onClick={e => this.onGridTypeChange(e, LiveChartGridOptions.FourByFour)}
                                active={
                                    this.appStore.storage.liveChartSettings.liveChartSelectedGrid ==
                                    LiveChartGridOptions.FourByFour
                                }
                            >
                                4x4
                            </DropdownItem>
                        </>
                    )}
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }

    @bind
    @action
    private onGridTypeChange(event: React.MouseEvent<HTMLElement>, v: LiveChartGridOptions) {
        event.preventDefault();

        this.appStore.storage.liveChartSettings.liveChartSelectedGrid = v;
    }

    @inject
    private appStore!: AppStore;
}
